import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// sessionStorage detector 추가
const sessionStorageDetector = {
  name: 'sessionStorage',
  lookup() {
    return sessionStorage.getItem('language');
  },
  cacheUserLanguage(lng) {
    sessionStorage.setItem('language', lng);
  },
};

// 커스텀 detector 등록
const languageDetector = new LanguageDetector();
languageDetector.addDetector(sessionStorageDetector);

i18n
  .use(HttpBackend) // 번역 파일 로드
  .use(languageDetector) // 커스텀 언어 감지기 사용
  .use(initReactI18next) // React와 연결
  .init({
    fallbackLng: 'ko', // 기본 언어 설정
    supportedLngs: ['ko', 'en', 'zh'], // 지원하는 언어
    interpolation: {
      escapeValue: false, // React는 XSS 방어를 위해 escape 필요 없음
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // 번역 파일 경로
    },
    detection: {
      order: ['sessionStorage'], // sessionStorage에서 언어 감지
      caches: ['sessionStorage'], // sessionStorage에 언어 저장
    },
    // debug: true, // 디버깅 모드 활성화
  });

export default i18n;
